module.exports = __webpack_public_path__ + "static/media/benedict-chan-200x200.6e44fdfe.jpg";